"use strict";

exports.__esModule = true;
exports.TextureWrap = exports.TextureRegion = exports.TextureFilter = exports.Texture = exports.FakeTexture = void 0;
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
var Texture = /*#__PURE__*/function () {
  function Texture(image) {
    this._image = image;
  }
  var _proto = Texture.prototype;
  _proto.getImage = function getImage() {
    return this._image;
  };
  return Texture;
}();
exports.Texture = Texture;
var TextureFilter;
exports.TextureFilter = TextureFilter;
(function (TextureFilter) {
  TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
  TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
  TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
  TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
  TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
  TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
  TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear"; // WebGLRenderingContext.LINEAR_MIPMAP_LINEAR
})(TextureFilter || (exports.TextureFilter = TextureFilter = {}));
var TextureWrap;
exports.TextureWrap = TextureWrap;
(function (TextureWrap) {
  TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
  TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
  TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat"; // WebGLRenderingContext.REPEAT
})(TextureWrap || (exports.TextureWrap = TextureWrap = {}));
var TextureRegion = function TextureRegion() {
  this.u = 0;
  this.v = 0;
  this.u2 = 0;
  this.v2 = 0;
  this.width = 0;
  this.height = 0;
  this.degrees = 0;
  this.offsetX = 0;
  this.offsetY = 0;
  this.originalWidth = 0;
  this.originalHeight = 0;
};
exports.TextureRegion = TextureRegion;
var FakeTexture = /*#__PURE__*/function (_Texture) {
  _inheritsLoose(FakeTexture, _Texture);
  function FakeTexture() {
    return _Texture.apply(this, arguments) || this;
  }
  var _proto2 = FakeTexture.prototype;
  _proto2.setFilters = function setFilters(minFilter, magFilter) {};
  _proto2.setWraps = function setWraps(uWrap, vWrap) {};
  _proto2.dispose = function dispose() {};
  return FakeTexture;
}(Texture);
exports.FakeTexture = FakeTexture;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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